// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"866a54df874a22eb5af1","339":"591b389f4b649e2dbf22"}[chunkId] + ".js";
};